import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function initScrollProgressBar() {
    const progressBar = document.querySelector('.progress-bar')
    const progressBarWrap = document.querySelector('.progress-bar-wrap')

    // Animate the progress bar as you scroll
    gsap.to(progressBar, {
        scaleX: 1,
        ease: 'none', // no ease, we control smoothness with the 'scrub' property
        scrollTrigger: {
            trigger: document.body, // Track the entire page
            start: 'top top',
            end: 'bottom bottom',
            scrub: 0.5 // control the amount of time it takes for the bar to catch up with scroll position
        }
    })
}

// Initialize Scroll Progress Bar
document.addEventListener('DOMContentLoaded', () => {
    initScrollProgressBar()
})
